import CustomSwitch from '@components/CustomSwitch';
import Grid from '@mui/material/Grid';
import fieldRequiredProps from '@utils/formik/fieldRequiredProps';
import { FieldProps } from 'formik';

import { CommonFieldProps, IFormValues, validationSchema } from '../../constants/formik';

const SwitchField = ({ form, field, label }: FieldProps<IFormValues> & CommonFieldProps) => (
  <Grid item container justifyContent="space-between" alignItems="center">
    <CustomSwitch {...fieldRequiredProps(form, validationSchema, field.name)} label={label} />
  </Grid>
);

export default SwitchField;
